import * as yup from "yup";

import { FormikProvider, useFormik } from "formik";

import { useTranslation } from "next-i18next";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import TextInputWithFormik from "../TextInput/TextInputWithFormik";

const JobIdModal = ({ open, toggleModal, onSubmit }) => {
  const { t } = useTranslation();

  const onCancel = () => {
    resetForm();
    toggleModal();
  };

  const fieldRequired = t("general.validation.required");

  const validationSchema = yup.object().shape({
    job: yup.string().required(fieldRequired),
  });

  const formik = useFormik({
    initialValues: {
      job: "",
    },
    enableReinitialize: true,
    onSubmit: ({ job }) => {
      onSubmit(job);
      toggleModal();
      resetForm();
    },
    validationSchema,
  });

  const { handleSubmit, resetForm } = formik;

  return (
    <Modal show={open} onHide={onCancel} centered size="sm">
      <Modal.Header closeButton className="border border-bottom-0 pb-0">
        <h1 className="fw-bold">{t("views.checkin.job.title")}</h1>
      </Modal.Header>
      <Modal.Body className="pt-0 pb-0" style={{ minHeight: 135 }}>
        <Form noValidate className="" onSubmit={handleSubmit}>
          <FormikProvider value={formik}>
            <TextInputWithFormik
              name="job"
              label={""}
              type="number"
              placeholder={""}
              required
              style={{ minHeight: 56 }}
            />
          </FormikProvider>
          <div className="mt-4 d-flex justify-content-center mb-4">
            <Button variant="secondary" onClick={onCancel} className="me-3">
              {t("general.cancel")}
            </Button>
            <Button variant="primary" type="submit">
              {t("general.submit")}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default JobIdModal;
